// extracted by mini-css-extract-plugin
export default {"wrapper":"headline__wrapper__EmgAR","container":"headline__container__DyIYR","title":"headline__title__KdpbA","description":"headline__description__uoWVQ"};